export default __webpack_public_path__ + "static/media/DAI-BUSD.ffb9cb83.png";